/** Формат «2 ч. 32 мин» — такой же, как в исходной таблице. */
export function formatHM(seconds: number): string {
  const total = Math.max(0, Math.floor(seconds / 60))
  const h = Math.floor(total / 60)
  const m = total % 60
  if (h && m) return `${h} ч. ${m} мин`
  if (h) return `${h} ч.`
  return `${m} мин`
}

/** Живой таймер в шапке — здесь секунды важны. */
export function formatHMS(seconds: number): string {
  const s = Math.max(0, Math.floor(seconds))
  const pad = (n: number) => String(n).padStart(2, '0')
  return `${pad(Math.floor(s / 3600))}:${pad(Math.floor((s % 3600) / 60))}:${pad(s % 60)}`
}

export function formatTime(iso: string | null): string {
  if (!iso) return ''
  return new Date(iso).toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' })
}

export function formatDate(iso: string | null): string {
  if (!iso) return ''
  const d = iso.length <= 10 ? new Date(`${iso}T00:00:00`) : new Date(iso)
  return d.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric' })
}

export function formatMoney(value: string | number | null | undefined): string {
  const n = Number(value ?? 0)
  return n.toLocaleString('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ₽'
}

/**
 * Часы для узкой плитки: «4 ч 07 м».
 *
 * Обычный формат «4 ч. 7 мин» на телефоне переносится на вторую строку, и
 * соседние плитки разъезжаются по высоте.
 */
export function formatHMShort(seconds: number): string {
  const total = Math.max(0, Math.floor(seconds / 60))
  const h = Math.floor(total / 60)
  const m = total % 60
  if (!h) return `${m} м`
  return `${h} ч ${String(m).padStart(2, '0')} м`
}

/** Сумма без копеек: в плитке важен порядок, а не рубль. */
export function formatMoneyShort(value: string | number | null | undefined): string {
  const n = Math.round(Number(value ?? 0))
  return n.toLocaleString('ru-RU') + ' ₽'
}

export function todayISO(): string {
  const d = new Date()
  const pad = (n: number) => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
}

export function monthBounds(anchor = new Date()): { from: string; to: string } {
  const pad = (n: number) => String(n).padStart(2, '0')
  const y = anchor.getFullYear()
  const m = anchor.getMonth()
  const last = new Date(y, m + 1, 0).getDate()
  return { from: `${y}-${pad(m + 1)}-01`, to: `${y}-${pad(m + 1)}-${pad(last)}` }
}

/** Список последних месяцев для выпадающего фильтра. */
export function recentMonths(count = 12): { value: string; label: string; from: string; to: string }[] {
  const out = []
  const now = new Date()
  for (let i = 0; i < count; i++) {
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1)
    const { from, to } = monthBounds(d)
    out.push({
      value: from.slice(0, 7),
      label: d.toLocaleDateString('ru-RU', { month: 'long', year: 'numeric' }),
      from,
      to,
    })
  }
  return out
}

/** Локальное время в ISO-строку для input[type=datetime-local]. */
export function toLocalInput(iso: string | null): string {
  if (!iso) return ''
  const d = new Date(iso)
  const pad = (n: number) => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(
    d.getMinutes(),
  )}`
}

export function fromLocalInput(value: string): string {
  return new Date(value).toISOString()
}

/** Русское склонение после числа: 1 задача, 2 задачи, 5 задач. */
export function plural(n: number, one: string, few: string, many: string): string {
  const abs = Math.abs(n) % 100
  const last = abs % 10
  if (abs > 10 && abs < 20) return many
  if (last > 1 && last < 5) return few
  if (last === 1) return one
  return many
}
